import { filter } from 'lodash';
import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination
} from '@mui/material';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { FormControl, InputLabel, Select, MenuItem,Box } from "@mui/material";

import { UserListHead, UserListToolbar, UserMoreMenu, UserForm } from '../sections/@dashboard/user';
// mock
import { getFaceList } from 'src/api/faceRegistration';
import { getURL } from "src/utils/config";
import axios from "axios";
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'Id', label: 'S No', alignRight: false },
  { id: 'FaceId', label: 'Face Id', alignRight: false },
  { id: 'Name', label: 'Name', alignRight: false },
  { id: 'Location', label: 'Location', alignRight: false },
  { id: 'Contractor', label: 'Contractor Name', alignRight: false },
  { id: 'Department', label: 'Department', alignRight: false },
  { id: 'CreatedOn', label: 'CreatedOn', alignRight: false },
  { id: 'Status', label: 'Status', alignRight: false },  
  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.Name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function FaceList() {
  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [isOpen, setOpen] = useState(false);

  const [registerFaces, setRegisterFaces] = useState([])
  
  const [locationNames, setLocationNames] = useState([]); // Initialize as an empty array
  
  const [locationError, setLocationError] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("");

  const [apiData, setApiData] = useState(null); // New state for storing API data
  const [selectedLocationId, setSelectedLocationId] = useState(null); // New state to stor


  useEffect(() => {
    const fetchData = async () => {
      
      const apiUrl = getURL("employee-shifts-info/location-names?status=1");
      const AUTH_TOKEN = `${localStorage.getItem('token_type')} ${localStorage.getItem('access_token')}`;
      
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: AUTH_TOKEN,
          },
        });

        const extractedLocationNames = response.data.map(item => item.LocationName);
        setLocationNames(extractedLocationNames);
        
        setApiData(response.data);
      } catch (error) {
        console.error('Error:', error);
      }
    };
  

    fetchData();
  }, []);

  useEffect(() => {
    if(selectedLocationId !== null){
      handleDetailsReload()
    }
  }, [selectedLocationId])

  const getLocation = (locationId) => {
    const location = apiData.find((loc) => loc.Id === locationId);
    return location ? location.LocationName : '';
  };

  const handleDetailsReload = () => {
    const data = {
      location_id: selectedLocationId
    };

    getFaceList(data, (is_success, response) => {
      if (is_success && response.status === 200) {      
        const filteredData = response.data.filter(item => item.LocationId === selectedLocationId);
        setRegisterFaces(filteredData)  
        // setRegisterFaces(response.data)
      }
    })
  };



  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = registerFaces.map((n) => n.Name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - registerFaces.length) : 0;

  const filteredUsers = applySortFilter(registerFaces, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  function handleDialog () {
    setOpen(true)
  }
  
  const updateLocation = (value) => {
    setSelectedLocation(value);
    const selectedLocationObject = apiData.find((location) => location.LocationName === value);
    setSelectedLocationId(selectedLocationObject ? selectedLocationObject.Id : null);
    localStorage.setItem("NetLocation", value);
  }

  useEffect(() => {
    const savedLocation = localStorage.getItem("NetLocation");
    if(savedLocation && apiData) {
      updateLocation(savedLocation);
    }  
  }, [apiData]);


  const handleLocationChange = (value) => {
    updateLocation(value);
  };


  return (
    <Page title="Face Register List">
      <Container maxWidth="xxl" sx={{p:0}}>
        <UserForm isOpen={isOpen} setOpen={setOpen}/>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Face Register List
          </Typography>
          <Button variant="contained" onClick={handleDialog} component={RouterLink} to="/add-face" startIcon={<Iconify icon="eva:plus-fill" />}>
            Register New Face
          </Button>
        </Stack>

        <Card>


<Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap', // optional if screen can be small
    gap: 2, // spacing between elements
  }}
>
  {/* Dropdown (Location Selector) on the left */}
                        <FormControl sx={{ minWidth: 300 ,ml : 2}}>
                          <InputLabel id="location-name-label" sx={{ color: locationError ? 'red' : 'gray' }}>Location</InputLabel>
                          <Select
                            labelId="location-name-label"
                            label="Location"
                            value={selectedLocation}
                            onChange={(e) => handleLocationChange(e.target.value)}
                            error={locationError}
                          >
                          {locationNames
                         .map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}

                          </Select>
                        </FormControl>

  {/* Search Toolbar on the right */}
  <UserListToolbar
    numSelected={selected.length}
    filterName={filterName}
    onFilterName={handleFilterByName}
  />
</Box>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={registerFaces.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row,index) => {
                    const { Id, Name, Status, CreatedOn ,ProfileUrl ,ClientId ,LocationId ,ContractorName ,DepartmentName} = row;

                    return (
                      <TableRow
                        hover
                        key={Id}
                        tabIndex={-1}
                      >
                        <TableCell align="left">{index +1}</TableCell>
                         <TableCell align="left">{Id}</TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          <Stack direction="row" alignItems="center" spacing={2}>
                          <Avatar alt={Name} src={ProfileUrl || undefined}>
                            {!ProfileUrl && Name.charAt(0)}
                          </Avatar>
                          <Typography variant="subtitle2" noWrap>
                            {Name}
                          </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">{getLocation(LocationId)}</TableCell>      
                        <TableCell align="left">{ContractorName ? ContractorName : "N/A"}</TableCell>   
                        <TableCell align="left">{DepartmentName ? DepartmentName : "N/A" }</TableCell>   
   
                        <TableCell align="left">{CreatedOn}</TableCell>   
                        <TableCell align="left">
                          <Label variant="ghost" color={(Status === 0 && 'error') || 'success'}>
                            {Status === 1 ? "Active": "Terminated"}
                          </Label>
                        </TableCell>                                          
                        

                        <TableCell align="right">
                        <UserMoreMenu rowData={{ Id, Name, CreatedOn, Status ,ClientId ,ContractorName ,DepartmentName ,LocationId}} handleDetailsReload={handleDetailsReload} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={9} />
                    </TableRow>
                  )}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={registerFaces.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
